// extracted by mini-css-extract-plugin
export default {"CardContainer":"InstructionsView_CardContainer__ZHELG"};